import { useQuery } from '@tanstack/react-query';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';

export const fetchCheckReleaseVersion = async (version: string) => {
  const { data } = await axiosInstance.get(API_ROUTES.releaseNoteCheckVersion(version));

  return data;
};

const useCheckReleaseVersion = (version: string) =>
  useQuery({
    queryKey: ['release-note-check-version', version],
    queryFn: () => fetchCheckReleaseVersion(version),
    enabled: !!version,
  });
export default useCheckReleaseVersion;
